import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from './page-header.component';
import { RouterModule } from '@angular/router';
import { ModalChatModule } from '../modal-chat/modal-chat.module';
import { OrderModule } from 'ngx-order-pipe';



@NgModule({
  declarations: [
    PageHeaderComponent
  ],
  exports: [
    PageHeaderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    OrderModule
  ]
})
export class PageHeaderModule { }
